import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DynamicAutocomplete = ({
  label,
  options = [],
  value,
  error,
  onChange,
  multiple = false,
  sx,
  disabled = false,
  format = "YYYY-MM-DD",
  loading = false,
  type = "autocomplete",
  valueStartDate,
  valueEndate,
}) => {
  if (type === "date") {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={value ? dayjs(value) : null}
          format={format}
          onChange={(newValue) =>
            onChange(newValue ? newValue.format("YYYY-MM-DD") : "")
          }
          disabled={disabled}
          slotProps={{
            textField: {
              size: "small",
              sx,
              error: !!error,
              // helperText: error,
            },
          }}
        />
      </LocalizationProvider>
    );
  }
  // console.log(loading, 'load')

  return (
    <Autocomplete
      multiple={multiple}
      options={options}
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option?.label || option?.toString()}
      isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
      // loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          // InputProps={{
          //   ...params.InputProps,
          //   endAdornment: (
          //     <>
          //       {loading && <CircularProgress color="inherit" size={20} />}
          //       {params.InputProps.endAdornment}
          //     </>
          //   ),
          // }}
        />
      )}
      sx={sx}
    />
  );
};

export default DynamicAutocomplete;
